<template>
	<div>
		<label class="flex">
			<input type="hidden" :name="name" value="false" :readonly="readonly" />
			<input type="checkbox" :name="name" :id="name" class="hidden" :readonly="readonly" :checked="isChecked" @click="toggle">
			<span role="checkbox" tabindex="0" :aria-checked="isChecked" class="group relative inline-flex items-center justify-center flex-shrink-0 h-5 w-10 cursor-pointer focus:outline-none float-left">
			  <span aria-hidden="true" class="bg-gray-200 absolute h-4 w-9 mx-auto rounded-full transition-colors ease-in-out duration-200" :class='{"bg-teal-600": isChecked}'></span>
			  <span aria-hidden="true" class="translate-x-0 absolute left-0 inline-block h-5 w-5 border border-gray-200 rounded-full bg-white shadow transform group-focus:shadow-outline group-focus:border-blue-300 transition-transform ease-in-out duration-200" :class='{"translate-x-5": isChecked}'></span>
			</span>

			<p class="text-sm inline-block float-left ml-2 cursor-pointer" :class="{'font-semibold': isChecked}"><slot></slot></p>
			<div class="clear-both"></div>
		</label>
	</div>
</template>

<script>
	export default {
		name: 'form.checkbox',
		props: {
			name: {
				required: true,
			},
			checked: {
				type: Boolean,
				default: false
			},
			readonly: {
				type: Boolean,
				default: false
			},
			returnElements: {
				required: false,
			}
		},
		watch: {
			checked: function(val, oldVal) {
				this.isChecked = this.checked;
			}
		},
		data() {
			return {
				isChecked: false
			}
		},
		mounted() {
			this.isChecked = (this.checked) ? this.checked : false;
		},
		methods: {
			toggle() {
				if(!this.readonly) {
					if(this.isChecked) {
						this.isChecked = false;
					} else {
						this.isChecked = true;
					}

					let returnVal = this.isChecked;

					// add return data to emitted data if passed to component
					if(this.returnElements) {
						returnVal = {checked: this.isChecked};

						Object.keys(this.returnElements).forEach((el) => {
							returnVal[el] = this.returnElements[el];
						})
					}
					this.$emit('updated', returnVal);
				}
			}
		}
	}
</script>